import { useContext } from 'react';
import { ConfirmationModalContext } from '@app/shared/contexts/ConfirmationModalContext';
import { ConfirmationModalValues } from '@app/types/core/confirmation-modal';

const useConfirmationModal = (): ConfirmationModalValues => {
  const context = useContext(ConfirmationModalContext);

  if (!context)
    throw new Error(
      'ConfirmationModalContext must be use inside ConfirmationModalProvider'
    );

  return context;
};

export default useConfirmationModal;
